import { h } from './pragma.mjs';
import rozpracovane from './rozpracovane.jsx';
import { getValidSetting, toggleSubMenu } from '../utils/common.mjs';
import { settings } from '../config/settingsFactory.mjs';
import { renderLoginComponent } from '../components/Login/loginService.mjs';

export default (aktivni, isPublic) => {
    
    const getServiceList = (groupCode) => {
        const services = getValidSetting(settings.clientSettings?.openServices, [], 'clientSettings.openServices')
        .find(group => group.groupCode === groupCode)
        ?.services || [];

        return services.map(service => (
            <li class="vdp-nav-item vdp-bg-dark-govcz" role="none">
                <a class="vdp-a vdp-nav-link" href="#" onClick ={(event) => {
                    event.preventDefault();
                    if (isPublic) { 
                        service.publicAction == 'renderLogin' ? renderLoginComponent(service.code, event) : window.location.href = getValidSetting(service.publicAction, "#", "settings service.publicAction service.code: " + service.code);
                    } else {
                        service.privateAction == 'initFormio' ? window.initFormio(service.code, null, null) : window.location.href = getValidSetting(service.privateAction, "#", "settings service.privateAction service.code: " + service.code); 
                    }
                }} target="_blank" title="" role="menuitem">
                    {`${service.description} (${service.code})`}
                    {service.icon && <span>&nbsp;<gov-icon class="liIcon" type="basic" name="box-arrow-up-right"></gov-icon></span>}
                </a>
            </li>
        ));
    };

    return (
        <gov-tabs-item id="sluzby" label="Služby" default={aktivni}>

            <div id="SluzbyTab" class="tabcontent">
                <div class="sides-auto">

                    <div class="vdp-col-12">
                        <h1>Vyberte službu, k níž chcete učinit podání</h1>
                    </div>

                    <div class="vdp-g-lg-4">
                        <div class="vdp-col-6" id="sidebar">
                            <nav class="vdp-navbar-dark">
                                <h2>Katastr nemovitostí</h2>
                                <ul class="vdp-nav vdp-flex-column vdp-ul" role="menu">

                                    <li class="vdp-nav-item vdp-bg-dark-govcz" role="none">
                                        <a id="linkToNV" class="vdp-a vdp-nav-link" href={ isPublic ? getValidSetting(settings.urls?.NV?.public,'#','NV link public') : getValidSetting(settings.urls?.NV?.private,'#','NV link private')} target="_blank" title="" role="menuitem">
                                            Návrh na vklad do
                                            katastru
                                            nemovitostí (S8419)&nbsp;<gov-icon class="liIcon" type="basic" name="box-arrow-up-right"></gov-icon>
                                        </a>
                                    </li>

                                    <li class="vdp-nav-item vdp-bg-dark-govcz" role="none">
                                        <a class="vdp-a vdp-nav-link zoverlay" href="#" title="" role="menuitem" onClick={(e) => toggleSubMenu(e)}>
                                        Poskytnutí údajů z
                                            katastru
                                                nemovitostí a dřívějších pozemkových evidencí (S8190)<span class="chevron">◀</span>
                                            
                                        </a>
                                        <ul class="submenu" style="display: none;">
                                            <li class="vdp-nav-item" role="none">
                                                <a class="vdp-a vdp-nav-link" href={ isPublic ? getValidSetting(settings.urls?.DPN?.public,'#','DPN link public') : getValidSetting(settings.urls?.DPN?.private,'#','DPN link private')} role="menuitem" target="_blank">E-shop s údaji katastru&nbsp;<gov-icon class="liIcon" type="basic" name="box-arrow-up-right"></gov-icon></a>
                                            </li>
                                            <li class="vdp-nav-item" role="none">
                                                <a class="vdp-a vdp-nav-link" href={ isPublic ? getValidSetting(settings.urls?.NAH?.public,'#','NAH link public') : getValidSetting(settings.urls?.NAH?.private,'#','NAH link private')} role="menuitem" target="_blank">Nahlížení&nbsp;<gov-icon class="liIcon" type="basic" name="box-arrow-up-right"></gov-icon></a>
                                            </li>
                                            <li class="vdp-nav-item" role="none">
                                                <a id="ssz-link-submenu" class="vdp-a vdp-nav-link" href={ isPublic ? getValidSetting(settings.urls?.SSZ?.public,'#','SSZ link public') : getValidSetting(settings.urls?.SSZ?.private,'#','SSZ link private')} role="menuitem" target="_blank">Služba sledování změn&nbsp;<gov-icon class="liIcon" type="basic" name="box-arrow-up-right"></gov-icon></a>
                                            </li>
                                            {/* <li class="vdp-nav-item" role="none">
                                                <a id="toastVfk" class="vdp-a vdp-nav-link inactive-link" href="#" role="menuitem">Výměnný formát katastru</a>
                                            </li> */}
                                            
                                        </ul>
                                    </li>

                                    {/* <div id="services" class="vdp-content"></div>   */}
                                    {getServiceList('katastr')}
                                </ul>
                                <br />
                                <h2>Zeměměřictví</h2>
                                <ul class="vdp-nav vdp-flex-column vdp-ul" role="menu">
                                    {getServiceList('zememerictvi')}
                                </ul>
                                <br />
                                <h2>RÚIAN</h2>
                                <ul class="vdp-nav vdp-flex-column vdp-ul" role="menu">
                                    {getServiceList("ruian")}
                                </ul>
                                <br />
                            </nav>
                        </div>
                        {rozpracovane(isPublic) }
                     
                    </div>

                </div>
            </div>

        </gov-tabs-item>
    )
}